import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";

import Icon from "../../../components/Icon";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "../../../components/ErrorMessage";
import ShowPassword from "../../../components/ShowPassword";
import AccessDeniedPage from "../../Page/AccessDeniedPage/AccessDeniedPage";
import OperatorIcon from "../../../components/OperatorIcon";
import { authContext } from "../../../context/AuthContext/AuthContext";
import { registerUserValidation } from "../../../utils/validation/validation";

const RegisterAuth = () => {
  const setting = useSelector((state) => state.meta?.setting);

  const { isStaffPage, handleRegister } = useContext(authContext);

  // Validation
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { isTerms: false },
    resolver: yupResolver(registerUserValidation),
  });

  if (isStaffPage && !setting?.isRegisterStaff) return <AccessDeniedPage />;

  return (
    <>
      <SiteTitle title="ایجاد حساب کاربری" />

      <section className="auth bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="/assets/images/auth/auth-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="/assets/images/logo.svg" alt="" />
              </Link>
              <h4 className="mb-12">
                ایجاد حساب کاربری{" "}
                {isStaffPage && (
                  <span className="text-primary fw-semibold">همکار</span>
                )}
              </h4>
              <p className="mb-32 text-secondary-light text-lg">
                به <span>نت بوف</span> خوش آمدید، لطفا اطلاعات حساب خود را تکمیل
                کنید
              </p>
            </div>
            <form autoComplete="off" onSubmit={handleSubmit(handleRegister)}>
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="qlementine-icons:rename-16" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="نام"
                    {...register("firstName")}
                  />
                </div>

                <ErrorMessage message={errors.firstName?.message} />
              </div>
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="qlementine-icons:rename-16" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="نام خانوادگی"
                    {...register("lastName")}
                  />
                </div>
                <ErrorMessage message={errors.lastName?.message} />
              </div>
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:id-card" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="کدملی"
                    inputMode="numeric"
                    {...register("nationalNumber")}
                  />
                </div>
                <ErrorMessage message={errors.nationalNumber?.message} />
              </div>
              <div className="mb-20">
                <div className="position-relative ">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="quill:phone" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      placeholder="شماره موبایل"
                      inputMode="numeric"
                      {...register("phoneNumber")}
                    />
                  </div>
                  <OperatorIcon phoneNumber={watch("phoneNumber")} />
                </div>
                <ErrorMessage message={errors.phoneNumber?.message} />
              </div>
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:email" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="پست الکترونیک"
                    inputMode="email"
                    {...register("email")}
                  />
                </div>
                <ErrorMessage message={errors.email?.message} />
              </div>
              <div className="mb-20">
                <div className="position-relative ">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="solar:lock-password-outline" />
                    </span>
                    <input
                      type="password"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="register-password"
                      placeholder="کلمه عبور"
                      {...register("password")}
                    />
                  </div>
                  <ShowPassword inputID="register-password" />
                </div>
                <ErrorMessage message={errors.password?.message} />
              </div>
              <div className="mb-20">
                <div className="position-relative ">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="solar:lock-password-outline" />
                    </span>
                    <input
                      type="password"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="register-confirm-password"
                      placeholder="تکرار کلمه عبور"
                      {...register("confirmPassword")}
                    />
                  </div>

                  <ShowPassword inputID="register-confirm-password" />
                </div>
                <ErrorMessage message={errors.confirmPassword?.message} />
              </div>
              <div>
                <div className="d-flex justify-content-between gap-2">
                  <Controller
                    control={control}
                    render={({ field: { value, onChange, onBlur } }) => (
                      <div className="form-check style-check d-flex align-items-start">
                        <input
                          className="form-check-input border border-neutral-300 mt-4"
                          type="checkbox"
                          id="isTerms"
                          onChange={(e) => {
                            const value = e.target.checked;
                            onChange(value);
                          }}
                          onBlur={onBlur}
                          checked={value}
                        />
                        <label
                          className="form-check-label text-sm"
                          htmlFor="isTerms"
                        >
                          با تمامی
                          <Link
                            to="/terms"
                            className="text-primary-600 fw-semibold mx-6"
                          >
                            قوانین و مقررات
                          </Link>
                          موافقم
                        </label>
                      </div>
                    )}
                    name="isTerms"
                  />
                </div>
                <ErrorMessage message={errors.isTerms?.message} />
              </div>
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                ثبت و ادامه
              </button>
              {setting?.isRegisterStaff && (
                <>
                  <div className="mt-32 center-border-horizontal text-center">
                    <span className="bg-base z-1 px-4">
                      یا ثبت نام به عنوان
                    </span>
                  </div>
                  <div className="mt-32">
                    <Link
                      to={
                        isStaffPage ? "/auth/register" : "/auth/register/staff"
                      }
                      type="button"
                      className="fw-semibold text-primary-light py-16  border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                    >
                      <Icon
                        icon={
                          isStaffPage
                            ? "famicons:person-circle"
                            : "material-symbols:server-person-rounded"
                        }
                        className="text-primary-600 text-xl line-height-1"
                      />
                      {isStaffPage ? "مشتری" : "همکار"}
                    </Link>
                  </div>
                </>
              )}
              <div className="mt-32 text-center text-sm">
                <p className="mb-0">
                  حساب کاربری دارید؟{" "}
                  <Link
                    to="/auth/login"
                    className="text-primary-600 fw-semibold"
                  >
                    ورود به حساب کاربری
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default RegisterAuth;
